/* Gallery2 hero only: present the existing Shopify Forms offer inline at every width. */
(() => {
  const slot = document.querySelector('[data-gl2-collection-offer]');
  if (!slot || slot.dataset.bound) return;
  slot.dataset.bound = 'true';
  const open = slot.querySelector('[data-gl2-offer-open]');
  const dismiss = slot.querySelector('[data-gl2-offer-dismiss]');
  const label = open.querySelector('span');
  let host;
  let root;
  let openedHere = false;
  let hadDialog = false;
  const teaser = () => root?.querySelector('[data-testid="form-teaser"]');
  function sync() {
    const original = teaser();
    const dialog = root?.querySelector('[role="dialog"]');
    if (original) label.textContent = original.getAttribute('aria-label') || original.querySelector('h3')?.textContent || '';
    slot.hidden = !original && !(openedHere && dialog);
    host?.toggleAttribute('data-gl2-inline-teaser', !!original);
    if (openedHere && hadDialog && !dialog) {
      openedHere = false;
      if (!slot.hidden) open.focus({preventScroll: true});
    }
    hadDialog = !!dialog;
  }
  open.addEventListener('click', () => {
    const original = teaser();
    if (!original) return;
    openedHere = true;
    original.click();
  });
  dismiss.addEventListener('click', () => {
    teaser()?.querySelector('[role="button"]')?.click();
    const hero = slot.closest('.gl2-collection-hero');
    (hero?.querySelector('a') || hero?.querySelector('h1'))?.focus({preventScroll: true});
  });
  function bind() {
    host = document.getElementById('app-embed-container-1132889');
    root = host?.shadowRoot;
    if (!root) return false;
    const style = document.createElement('style');
    style.dataset.gl2Offer = 'true';
    style.textContent = ':host([data-gl2-inline-teaser]) #app-embed:has([data-testid="form-teaser"]):not(:has([role="dialog"])) { display: none !important; }';
    root.append(style);
    new MutationObserver(sync).observe(root, {childList: true, subtree: true});
    sync();
    return true;
  }
  if (!bind()) {
    let attempts = 0;
    const timer = window.setInterval(() => {
      if (bind() || ++attempts >= 120) window.clearInterval(timer);
    }, 250);
    window.addEventListener('pagehide', () => window.clearInterval(timer), {once: true});
  }
})();
